import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_messages_distinctService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { input?: $frontendTypes.Utilities.Message[], criteria?: { application_name?: string, full_text_search?: string, date_from?: string, date_to?: string }, field: string, top?: number }): Promise<{ output?: { application_name?: string, value?: any }[], success?: boolean, error?: any[], count?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.field)) {
      $missingRequiredInParams.push('\'field\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

